import * as React from 'react';

export const Logo40seasColumn = ({ style }: { style?: React.CSSProperties }) => (
    <svg style={style} id="Warstwa_6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 152 74">
        <defs></defs>
        <g>
            <path
                fill="#0D49E1"
                d="M19,52.84c-6.09-.4-10.82-.98-10.82-4.21,0-3.46,5.6-4.32,9.63-4.32,5.44,.06,9.4,1.79,12.29,4.15l3.32-4.38c-3.48-2.71-9.19-5.01-15.28-5.01-10,0-15.98,3.8-15.98,9.97,0,6.74,7.72,8.76,15.82,9.39,7.02,.58,10.88,1.56,10.88,4.72s-4.24,4.67-9.74,4.67c-6.36,0-11.2-2.08-14.68-5.25l-3.42,3.98c4.29,3.98,10.66,6.51,17.95,6.51,10.49,0,15.93-4.61,15.93-10.49,0-6.39-6.74-9.05-15.88-9.74Z"
            />
            <path
                fill="#0D49E1"
                d="M56.24,39.08c-11.47,0-18.33,6.57-18.33,17.05s6.85,16.94,18.76,16.94c6.96,0,12.13-1.79,16.21-5.65l-3.7-4.21c-3.26,3.05-6.69,4.55-12.18,4.55-7.5,0-12.23-3.34-12.83-10.2h29.58c.11-.34,.16-.75,.16-1.5,0-11.06-6.96-17-17.68-17Zm-11.8,13.71c1.2-5.59,5.6-8.41,11.85-8.41,5.88,0,10.12,2.59,11.48,8.35l-23.33,.06Z"
            />
            <path
                fill="#0D49E1"
                d="M111.75,54.29c0-9.91-6.36-15.15-16.75-15.15-5.38,0-11.1,1.56-14.79,3.92l2.28,4.55c3.43-2.13,6.91-3.17,11.31-3.17,7.67,0,11.58,3.05,11.58,9.85v2.31c-2.34-3.05-6.9-5.65-13-5.65-6.42,0-14.95,2.77-14.95,11s8.54,11.06,14.95,11.06,10.66-2.59,13-5.65v.06c0,1.5,.38,3.05,1.14,4.44h6.58c-.98-1.84-1.36-3.75-1.36-6.11v-11.47Zm-6.25,8.18c-2.4,4.32-7.45,5.71-11.91,5.71-3.97,0-9.9-1.1-9.9-6.22s5.93-6.16,9.9-6.16c4.46,0,9.52,1.33,11.91,5.7v.98Z"
            />
            <path
                fill="#0D49E1"
                d="M135.12,52.84c-6.09-.4-10.82-.98-10.82-4.21,0-3.46,5.6-4.32,9.63-4.32,5.44,.06,9.4,1.79,12.29,4.15l3.32-4.38c-3.48-2.71-9.19-5.01-15.28-5.01-10,0-15.98,3.8-15.98,9.97,0,6.74,7.72,8.76,15.82,9.39,7.02,.58,10.88,1.56,10.88,4.72s-4.24,4.67-9.74,4.67c-6.36,0-11.2-2.08-14.68-5.25l-3.42,3.98c4.29,3.98,10.66,6.51,17.95,6.51,10.49,0,15.93-4.61,15.93-10.49,0-6.39-6.74-9.05-15.88-9.74Z"
            />
        </g>
        <g>
            <path
                fill="#0D49E1"
                d="M49.59,2.02h-5.19L19.63,22.92v3.83h24.27v7.12h5.69v-7.12h6.57v-4.77h-6.57V2.02Zm-5.74,19.96H27.35l16.51-13.51v13.51Z"
            />
            <path
                fill="#0D49E1"
                d="M108.3,17.97c0-13.03-11.03-9.02-11.05-17.04h-6.01c2.02,5.01,11.04,4.01,11.04,17.04s-9.02,12.03-11.04,17.04h6.01c.02-8.02,11.05-4.01,11.05-17.04Z"
            />
            <path
                fill="#0D49E1"
                d="M120.33,18c0-10.03-10.03-3.01-11.03-17.01h-6.02c0,9.99,11.03,4.97,11.03,17.01s-11.03,7.02-11.03,17.02h6.02c1-14.01,11.03-6.99,11.03-17.02Z"
            />
            <path
                fill="#0D49E1"
                d="M121.34,.93h-6.02c0,14.04,11.03,10.03,11.03,17.04s-11.03,3.01-11.03,17.04h6.02c1-17.04,11.03-12.03,11.03-17.04s-10.03,0-11.03-17.04Z"
            />
            <path
                fill="#0D49E1"
                d="M96.27,17.98c0-10.03-4.89-10.17-8.02-12.75-4.01-3.3-6.02-4.3-10.03-4.25-5.01,.06-19.05,1.05-19.05,17s14.04,16.91,19.05,16.98c4.01,.06,6.02-.95,10.03-4.25,3.13-2.58,8.02-2.71,8.02-12.74Zm-6.02,0c0,6.45-4.01,11.69-12.53,11.69s-12.53-5.23-12.53-11.69,4.01-11.69,12.53-11.69,12.53,5.23,12.53,11.69Z"
            />
        </g>
    </svg>
);
